'use strict';

import { newModalFromString } from '../components/modal';

export const bonusProductModalListener = (e) => {
    $('body').on('click', '#checkout-button-secure-checkout', function (e) {
        e.preventDefault();
        if ($('.wrapper-bonus-product-button').length > 0) {
            openBonusModal(e);
        } else {
            window.location.href = $(e.currentTarget).data('url');
        }
    });
};

export const openBonusModal = e => {
    if ($('.modal-was-closed').val() === 'true') {
        window.location.href = $(e.currentTarget).data('url');
        return;
    }
    if ($('.tingle-modal.layer-bonus-modal').length > 0) {
        return;
    }
    const htmlContent = $('#pendingBonusModal').clone().html();
    const onClose = () => {
        $('.modal-was-closed').val('true');
    };
    var modal = newModalFromString(htmlContent, false, ['layer-bonus-modal'], null, onClose);
    modal.open();
    $(modal.modalBox).addClass('rightModalAttribute');
    if ($('.layer-minicart-modal').hasClass('tingle-modal--visible')) {
        $(modal.modalBox).addClass('minicart-style');
    }
    $(modal.modalBox)
        .find('.close-button-info')
        .on('click', function () {
            modal.close();
        });
    $(modal.modalBox)
        .find('.js-proceed-to-checkout')
        .on('click', function (e) {
            $('.modal-was-closed').val('true');
            modal.close();
            if ($('.modal-was-closed').hasClass('klarna')) {
                $('.js-ModalExpressButton-klarna').trigger('click');
            } else if ($('.modal-was-closed').hasClass('apple')) {
                $('.js-ModalExpressButton-applePay').trigger('click');
            } else if ($('.modal-was-closed').hasClass('amazon')) {
                $('.js-ModalExpressButton-amazonPay').trigger('click');
            } else if ($('.modal-was-closed').hasClass('paypal')) {
                $('.js-ModalExpressButton-paypal').trigger('click');
            } else {
                window.location.href = $(e.currentTarget).data('url');
            }
        });
    $(modal.modalBox)
        .find('.js-choose-gift-details')
        .on('click', function (e) {
            var uuid = $(e.currentTarget).data('uuid');
            modal.close();
            $('.bonus-product-button[data-duuid="' + uuid + '"]').trigger('click');
        });
};
